import React from 'react';
import { FONT_BODY } from './theme';
import { CtaButton } from './ui';
import { ArrowIcon } from './icons';

const RoadmapCta: React.FC<{ onEarlyAccess: () => void }> = ({ onEarlyAccess }) => (
  <section
    id="roadmap"
    style={{ scrollMarginTop: 74, padding: 'clamp(34px,4vw,56px) clamp(16px,4vw,30px) clamp(30px,3.6vw,46px)' }}
  >
    <div style={{ maxWidth: 760, margin: '0 auto', textAlign: 'center' }}>
      <h2
        style={{
          font: `800 clamp(25px,3.4vw,36px)/1.18 ${FONT_BODY}`,
          letterSpacing: '-.032em',
          color: '#0F172A',
          margin: 0,
          textWrap: 'balance',
        }}
      >
        Your ambition. Your roadmap. Your AI workforce.
      </h2>
      <p style={{ font: `400 clamp(14px,1.25vw,16px)/1.6 ${FONT_BODY}`, color: '#475569', margin: '13px 0 0' }}>
        Free platform, free roadmap, and no commitment to see the whole plan.
      </p>
      <CtaButton variant="hero" onClick={onEarlyAccess} style={{ padding: '17px 30px', margin: '24px 0 0' }}>
        GET EARLY ACCESS
        <ArrowIcon size={16} />
      </CtaButton>
      <p style={{ font: `400 13px ${FONT_BODY}`, color: '#64748B', margin: '17px 0 0' }}>
        No credit card required · One school per 5-km radius
      </p>
    </div>
  </section>
);

export default RoadmapCta;
